import React, { useContext, useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { FiEdit2, FiTrash2, FiPlus } from 'react-icons/fi';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import "../../../../assets/css/admin/dashboard/AdminBlogs.css";
import AdminLayout from '../../../../layouts/admin/AdminLayout';
import AppContext from '../../../../context/AppContext';
import axios from 'axios';

const Blogs = () => {

  const { baseUrl, baseUrlForFile } = useContext(AppContext);

  const [Title, setTitle] = useState('');
  const [Category, setCategory] = useState('');
  const [Author, setAuthor] = useState('');
  const [Date, setDate] = useState('');
  const [Image, setImage] = useState(null);
  const [Excerpt, setExcerpt] = useState('');
  const [Content, setContent] = useState('');

  const [blogs, setBlogs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isBlogsLoading, setIsBlogsLoading] = useState(true);
  const [sgcShowAdd, setSgcShowAdd] = useState(false);
  const [sgcShowEdit, setSgcShowEdit] = useState(false);
  const [sgcEditData, setSgcEditData] = useState({});

  // ── NEW: loading state for New Post button (same pattern as CustomerDashboard) ──
  const [navLoading, setNavLoading] = useState(null);

  const handleNewPost = () => {
    setNavLoading('newPost');
    setTimeout(() => {
      setSgcShowAdd(true);
      setNavLoading(null);
    }, 600);
  };

  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'image'],
      ['clean'],
    ],
  };

  const viewAllBlogs = () => {
    setIsBlogsLoading(true);
    axios
      .get(`${baseUrl}/admin/blogs/viewAllBlogs`)
      .then((res) => { 
        console.log("*********log from the all blogs", res.data)
        setBlogs(res.data.data) }) // FIXED: 'blogs' ki jagah 'data'
      .catch((err) => { console.log(err) })
      .finally(() => setIsBlogsLoading(false));
  };

  useEffect(() => {
    viewAllBlogs();
  }, []);

  // ===================== VALIDATION (required fields) =====================
  const validateBlogForm = () => {
    if (!Title.trim()) return 'Title is required';
    if (!Category.trim()) return 'Category is required';
    if (!Author.trim()) return 'Author is required';
    if (!Date.trim()) return 'Date is required';
    if (!Excerpt.trim()) return 'Excerpt is required';
    return null;
  };

  const createBlog = () => {
    const validationError = validateBlogForm();
    if (validationError) {
      alert(validationError);
      return;
    }
    if (!Image) {
      alert('Cover Image is required');
      return;
    }

    setIsLoading(true);
    const formData = new FormData();
    formData.append('title', Title);
    formData.append('category', Category);
    formData.append('author', Author);
    formData.append('date', Date);
    formData.append('image', Image);
    formData.append('Excerpt', Excerpt); // FIXED: 'excerpt' ki jagah 'Excerpt'
    formData.append('content', Content);

    axios
      .post(`${baseUrl}/admin/blogs/createBlog`, formData)
      .then(() => {
        viewAllBlogs();
        setSgcShowAdd(false);
        setTitle(''); setCategory(''); setAuthor('');
        setDate(''); setImage(null); setExcerpt(''); setContent('');
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  };

  const updateBlog = () => {
    const validationError = validateBlogForm();
    if (validationError) {
      alert(validationError);
      return;
    }

    setIsLoading(true);
    const formData = new FormData();
    formData.append('id', sgcEditData.id);
    formData.append('title', Title);
    formData.append('category', Category);
    formData.append('author', Author);
    formData.append('date', Date);
    if (Image && typeof Image === 'object') {
      formData.append('image', Image);
    }
    formData.append('Excerpt', Excerpt); // FIXED: 'excerpt' ki jagah 'Excerpt'
    formData.append('content', Content);

    axios
      .post(`${baseUrl}/admin/blogs/updateBlog`, formData)
      .then(() => {
        viewAllBlogs();
        setSgcShowEdit(false);
        setTitle(''); setCategory(''); setAuthor('');
        setDate(''); setImage(null); setExcerpt(''); setContent('');
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  };

  const deleteBlog = (id) => {
    axios
      .delete(`${baseUrl}/admin/blogs/deleteBlog/${id}`)
      .then(() => viewAllBlogs())
      .catch((err) => console.log(err));
  };

  const sgcOpenEdit = (blog) => {
    setSgcEditData(blog);
    setTitle(blog.title);
    setCategory(blog.category);
    setAuthor(blog.author);
    setDate(blog.date);
    setImage(null);
    setExcerpt(blog.Excerpt); // FIXED: 'excerpt' ki jagah 'Excerpt' (database column capital E hai)
    setContent(blog.content || '');
    setSgcShowEdit(true);
  };

  return (
    <AdminLayout>
      <div className="blog-wrapper">
        <Container fluid>

          {/* HEADER */}
          <div className="blog-header">
            <div>
              <h2 className="blog-title">Blogs</h2>
              <p className="blog-subtitle">Publish wedding tips and stories.</p>
            </div>
            <button className="blog-add-btn" onClick={handleNewPost} disabled={navLoading === 'newPost'}>
              {navLoading === 'newPost' ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                  Loading...
                </>
              ) : (
                <>
                  <FiPlus size={14} /> New Post
                </>
              )}
            </button>
          </div>

          {/* BLOG CARDS GRID */}
          {isBlogsLoading ? (
            <div style={{ textAlign: 'center', padding: '60px 0' }}>
              <div className="spinner-border" role="status" style={{ color: '#ff8a8a' }}>
                <span className="visually-hidden">Loading...</span>
              </div>
              <p style={{ marginTop: '12px', color: '#888' }}>Loading blogs...</p>
            </div>
          ) : blogs.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px 0', color: '#888' }}>
              No blogs found
            </div>
          ) : (
          <Row className="g-4">
            {blogs.map((blog) => (
              <Col key={blog.id} xs={12} sm={6} xl={4}>
                <div className="blog-card">
                  <div className="blog-card-img-wrap">
                    <img
                      src={`${baseUrlForFile}/${blog.image}`}
                      alt={blog.title}
                      className="blog-card-img"
                    />

                  </div>
                  <div className="blog-card-body">
                    <span className="blog-category-badge">{blog.category}</span>
                    <h5 className="blog-card-title">{blog.title}</h5>
                    <p className="blog-card-meta">{blog.date} · {blog.author}</p>
                  </div>
                  <div className="blog-card-footer">
                    <button className="blog-edit-btn" onClick={() => sgcOpenEdit(blog)}>
                      <FiEdit2 size={13} /> Edit
                    </button>
                    <button className="blog-delete-btn" onClick={() => deleteBlog(blog.id)}>
                      <FiTrash2 size={13} />
                    </button>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
          )}

        </Container>
      </div>

      {/* ── ADD MODAL ───────────────────────────────── */}
      {sgcShowAdd && createPortal(
        <div className="blog-modal-overlay" onClick={() => setSgcShowAdd(false)}>
          <div className="blog-modal-box" onClick={(e) => e.stopPropagation()}>

            <div className="blog-modal-header">
              <div>
                <h5 className="blog-modal-title">New Blog Post</h5>
                <p className="blog-modal-subtitle">Share a wedding tip or story with your audience.</p>
              </div>
              <button className="blog-modal-close" onClick={() => setSgcShowAdd(false)}>×</button>
            </div>

            <div className="blog-modal-body">

              <div className="blog-form-group">
                <label className="blog-form-label">Title</label>
                <input
                  className="blog-form-input blog-input-focus"
                  type="text"
                  placeholder="e.g. 10 Mehndi décor ideas"
                  value={Title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>

              <Row className="g-3">

                <Col xs={12} md={6}>
                  <div className="blog-form-group">
                    <label className="blog-form-label">Cover Image</label>
                    <input
                      className="blog-form-input blog-file-input"
                      type="file"
                      accept="image/*"
                      onChange={(e) => setImage(e.target.files[0])}
                    />
                  </div>
                </Col>

                <Col xs={12} md={6}>
                  <div className="blog-form-group">
                    <label className="blog-form-label">Category</label>
                    <input
                      className="blog-form-input"
                      type="text"
                      placeholder="e.g. Decor, Tips"
                      value={Category}
                      onChange={(e) => setCategory(e.target.value)}
                    />
                  </div>
                </Col>

                <Col xs={12} md={6}>
                  <div className="blog-form-group">
                    <label className="blog-form-label">Author</label>
                    <input
                      className="blog-form-input"
                      type="text"
                      placeholder="Author name"
                      value={Author}
                      onChange={(e) => setAuthor(e.target.value)}
                    />
                  </div>
                </Col>

                <Col xs={12} md={6}>
                  <div className="blog-form-group">
                    <label className="blog-form-label">Date</label>
                    <input
                      className="blog-form-input"
                      type="text"
                      placeholder="May 17, 2026"
                      value={Date}
                      onChange={(e) => setDate(e.target.value)}
                    />
                  </div>
                </Col>

              </Row>

              <div className="blog-form-group">
                <label className="blog-form-label">Excerpt</label>
                <textarea
                  className="blog-form-input blog-form-textarea"
                  rows={3}
                  placeholder="Short summary shown on the blog list."
                  value={Excerpt}
                  onChange={(e) => setExcerpt(e.target.value)}
                />
              </div>

              <div className="blog-form-group">
                <label className="blog-form-label">Content</label>
                <ReactQuill
                  theme="snow"
                  value={Content}
                  onChange={setContent}
                  modules={quillModules}
                  placeholder="Write the full blog content here..."
                />
              </div>

            </div>

            <div className="blog-modal-footer">
              <button className="blog-cancel-btn" onClick={() => setSgcShowAdd(false)}>Cancel</button>
              <button className="blog-publish-btn" onClick={createBlog} disabled={isLoading}>
                {isLoading ? 'Publishing...' : 'Publish Post'}
              </button>
            </div>

          </div>
        </div>,
        document.body
      )}

      {/* ── EDIT MODAL ──────────────────────────────── */}
      {sgcShowEdit && createPortal(
        <div className="blog-modal-overlay" onClick={() => setSgcShowEdit(false)}>
          <div className="blog-modal-box" onClick={(e) => e.stopPropagation()}>

            <div className="blog-modal-header">
              <div>
                <h5 className="blog-modal-title">Edit Blog Post</h5>
                <p className="blog-modal-subtitle">Update the details of this blog post.</p>
              </div>
              <button className="blog-modal-close" onClick={() => setSgcShowEdit(false)}>×</button>
            </div>

            <div className="blog-modal-body">

              <div className="blog-form-group">
                <label className="blog-form-label">Title</label>
                <input
                  className="blog-form-input blog-input-focus"
                  type="text"
                  placeholder="e.g. 10 Mehndi décor ideas"
                  value={Title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>

              <Row className="g-3">

                <Col xs={12} md={6}>
                  <div className="blog-form-group">
                    <label className="blog-form-label">Cover Image</label>
                    <input
                      className="blog-form-input blog-file-input"
                      type="file"
                      accept="image/*"
                      onChange={(e) => setImage(e.target.files[0])}
                    />
                  </div>
                </Col>

                <Col xs={12} md={6}>
                  <div className="blog-form-group">
                    <label className="blog-form-label">Category</label>
                    <input
                      className="blog-form-input"
                      type="text"
                      placeholder="e.g. Decor, Tips"
                      value={Category}
                      onChange={(e) => setCategory(e.target.value)}
                    />
                  </div>
                </Col>

                <Col xs={12} md={6}>
                  <div className="blog-form-group">
                    <label className="blog-form-label">Author</label>
                    <input
                      className="blog-form-input"
                      type="text"
                      placeholder="Author name"
                      value={Author}
                      onChange={(e) => setAuthor(e.target.value)}
                    />
                  </div>
                </Col>

                <Col xs={12} md={6}>
                  <div className="blog-form-group">
                    <label className="blog-form-label">Date</label>
                    <input
                      className="blog-form-input"
                      type="text"
                      placeholder="May 17, 2026"
                      value={Date}
                      onChange={(e) => setDate(e.target.value)}
                    />
                  </div>
                </Col>

              </Row>

              <div className="blog-form-group">
                <label className="blog-form-label">Excerpt</label>
                <textarea
                  className="blog-form-input blog-form-textarea"
                  rows={3}
                  placeholder="Short summary shown on the blog list."
                  value={Excerpt}
                  onChange={(e) => setExcerpt(e.target.value)}
                />
              </div>

              <div className="blog-form-group">
                <label className="blog-form-label">Content</label>
                <ReactQuill
                  theme="snow"
                  value={Content}
                  onChange={setContent}
                  modules={quillModules}
                  placeholder="Write the full blog content here..."
                />
              </div>

            </div>

            <div className="blog-modal-footer">
              <button className="blog-cancel-btn" onClick={() => setSgcShowEdit(false)}>Cancel</button>
              <button className="blog-publish-btn" onClick={updateBlog} disabled={isLoading}>
                {isLoading ? 'Updating...' : 'Update Post'}
              </button>
            </div>

          </div>
        </div>,
        document.body
      )}

    </AdminLayout>
  );
};

export default Blogs;